import { useCallback, useEffect, useRef, useState } from "react";
import { ImageOff } from "lucide-react";

export default function AutoVideo({ src, className, testId }) {
  const [attempt, setAttempt] = useState(0);
  const [failedSrc, setFailedSrc] = useState(null);
  const retryTimer = useRef(null);
  const failed = failedSrc === src;
  const webm = /\.mp4(\?.*)?$/i.test(src || "") ? src.replace(/\.mp4(\?.*)?$/i, ".webm") : null;

  useEffect(() => () => clearTimeout(retryTimer.current), []);

  const attach = useCallback((el) => {
    if (!el) return;
    el.muted = true;
    el.defaultMuted = true;
    el.load();
    const p = el.play();
    if (p && p.catch) p.catch(() => {});
  }, []);

  const handleFinalError = () => {
    if (attempt < 3) {
      retryTimer.current = setTimeout(() => setAttempt((a) => a + 1), 2500);
    } else {
      setFailedSrc(src);
    }
  };

  if (failed) {
    return (
      <div
        className={`${className} flex items-center justify-center bg-[#0A0A0C]`}
        data-testid={testId}
        role="img"
        aria-label="Media temporarily unavailable"
      >
        <ImageOff size={28} className="text-[rgba(212,175,55,0.35)]" aria-hidden="true" />
      </div>
    );
  }

  return (
    <video
      key={`${src}-${attempt}`}
      ref={attach}
      autoPlay
      muted
      loop
      playsInline
      preload="auto"
      onClick={(e) => e.currentTarget.play().catch(() => {})}
      className={className}
      data-testid={testId}
    >
      <source src={src} type="video/mp4" onError={webm ? undefined : handleFinalError} />
      {webm && <source src={webm} type="video/webm" onError={handleFinalError} />}
    </video>
  );
}
